import { ApiResponseNHL, useFetchLeagueData } from '~/core/api';

import { Draft } from './types';

type QueryArgs = {
    baseUrl?: string;
    isEnabled: boolean;
};

export const useDraftPicksQuery = (args: QueryArgs): ApiResponseNHL<Draft> =>
    useFetchLeagueData('/draft-tracker/picks/now', args.isEnabled, args.baseUrl);
